import { IS_SEGMENT_ENABLED } from 'gatsby-env-variables'

import { sdkAnalytics, datadog } from '@itau-loans-www/services'
import { segment, windowTrackClick } from '@itau-loans-www/utils'
import '@itau-loans-www/utils/bootstrap'
import {
  getCookieBarStyles,
  setCookieBarStyles
} from '@itau-loans-www/utils/cookieBar'
import configure from 'itau-jn6-dep-www/packages/ds/configure'

import '../../common/styles/index.scss'
import wrapWithProvider from './wrap-with-provider'

sdkAnalytics.setup()

datadog.init()
datadog.logsInit()

configure()

export const onRouteUpdate = (locationProps) => {
  setCookieBarStyles(getCookieBarStyles())

  const clicksCallback = (currentButton) => {
    segment.buttonClick(currentButton)
  }
  if (IS_SEGMENT_ENABLED) {
    segment.init(locationProps)
    windowTrackClick(clicksCallback)
  }
}

export const wrapRootElement = wrapWithProvider
